import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (window.railsEnvironment == 'test' || document.documentElement.hasAttribute("data-turbolinks-preview") === true) {
      return;
    }

    window.googletag.cmd.push(function() {
      window.googletag.pubads().clear();
    });

    var tags       = JSON.parse(this.data.get("tags"));
    var categories = JSON.parse(this.data.get("categories"));
    var verticals  = JSON.parse(this.data.get("verticals"));

    if (window.googletag.pages.listing) {
      window.googletag.cmd.push(function() {
        window.googletag.pubads()
             .setTargeting('vertical', verticals)
             .setTargeting('tags-vertical', tags)
             .setTargeting('categoria', categories)
             .setTargeting('location', 'my_location');

        window.googletag.pubads().refresh([
          window.googletag.slots['listing_slot1'],
          window.googletag.slots['listing_slot2']
        ]);
      });
    } else {
      window.googletag.cmd.push(function() {
        window.googletag.slots['listing_slot1'] = window.googletag.defineSlot('/21858406487/pag-amarelas/listing-page/banner', [[320,50]], 'div-gpt-listing-banner')
                 .setTargeting('position', ['banner'])
                 .defineSizeMapping(window.googletag.sizes.mapBanner)
                 .addService(window.googletag.pubads());

        window.googletag.slots['listing_slot2'] = window.googletag.defineSlot('/21858406487/pag-amarelas/listing-page/side', [[300,250]], 'div-gpt-listing-side')
                 .setTargeting('position', ['side'])
                 .defineSizeMapping(window.googletag.sizes.mapSide)
                 .addService(window.googletag.pubads());

        window.googletag.pubads()
           .setTargeting('vertical', verticals)
           .setTargeting('tags-vertical', tags)
           .setTargeting('categoria', categories)
           .setTargeting('location', 'my_location');

        window.googletag.enableServices();

        window.googletag.display("div-gpt-listing-banner");
        window.googletag.display("div-gpt-listing-side");

        window.googletag.pages.listing = true;
      });
    }
  }
}
